import PropTypes from 'prop-types'
import classNames from 'classnames'

import Modal from '../common/Modal'
import CancelButton from '../common/buttons/CancelButton'
import SubmitButton from '../common/buttons/SubmitButton'
import { ReactComponent as ClapIcon } from '../../assets/images/common/icons/clap-icon.svg'

import classes from './AccountSegmentWelcomeModal.module.scss'

const AccountSegmentWelcomeModal = ({ isOpen, onAddFamilyMember, onGoToDashboard }) => (
  <Modal isOpen={isOpen} onClose={onGoToDashboard} className={classes.welcomeModalContent}>
    <div className={classNames(classes.welcomeModal, 'd-flex flex-column align-items-center text-center')}>
      <div className={classNames(classes.iconCircle, 'd-flex align-items-center justify-content-center')}>
        <ClapIcon className={classes.clapIcon} aria-hidden='true' />
      </div>

      <h2 className={classNames(classes.modalTitle, 'mt-4 mb-2')}>Welcome to Operation 36</h2>
      <p className={classNames(classes.modalSubtitle, 'mb-5')}>Your account is ready. Take a look around or add a family member to get started.</p>

      <div className='row w-100'>
        <div className='col-6'>
          <SubmitButton type='button' buttonMessage='Add Family Member' onClick={onAddFamilyMember} noTopMargin />
        </div>

        <div className='col-6'>
          <CancelButton onClick={onGoToDashboard} buttonMessage='Go to Dashboard' />
        </div>
      </div>
    </div>
  </Modal>
)

AccountSegmentWelcomeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onAddFamilyMember: PropTypes.func.isRequired,
  onGoToDashboard: PropTypes.func.isRequired,
}

export default AccountSegmentWelcomeModal
